import _slicedToArray from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useContext, useMemo, useState, useEffect } from 'react';
import { LazyPhaseContext } from './context';
export var usePhaseSubscription = function usePhaseSubscription() {
  var targetPhase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

  var _useContext = useContext(LazyPhaseContext),
      subscribe = _useContext.subscribe,
      currentPhase = _useContext.currentPhase;

  var _useState = useState(function () {
    return currentPhase() >= targetPhase;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      run = _useState2[0],
      setRun = _useState2[1]; // subscribe with memo instead of effect to retain tree order


  var unsubscribe = useMemo(function () {
    return subscribe(function (v) {
      return setRun(v >= targetPhase);
    });
  }, [subscribe, setRun, targetPhase]); // subscription is done on first render, here just unsubscribe

  useEffect(function () {
    return unsubscribe;
  }, [unsubscribe]);
  return run;
};